import { IconPack } from '@fortawesome/fontawesome-common-types';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faApple, faDocker, faGithub, faGitlab, faGoogle } from '@fortawesome/free-brands-svg-icons';

export const brandsSvgIconsPack: IconPack = {
  faApple,
  faDocker,
  faGithub,
  faGitlab,
  faGoogle,
};

export const getBrandIcon = (vendorSomewhere = '') => {
  const nameLowerCase = vendorSomewhere.toLowerCase();

  switch (true) {
    case nameLowerCase.includes('github'):
      return <IconProp>['fab', 'github'];
    case nameLowerCase.includes('dockerhub'):
      return <IconProp>['fab', 'docker'];
    case nameLowerCase.includes('bunny'):
      return <IconProp>['fak', 'rabbit'];
    default:
      return undefined;
  }
};
